import { render, staticRenderFns } from "./money-opition.vue?vue&type=template&id=16380cd6&"
import script from "./money-opition.vue?vue&type=script&lang=js&"
export * from "./money-opition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports